/**
 * Permission Helper for Role-Based Access Control
 * TFM Admin Dashboard - Tab-Level Permissions for Reports
 * Story: TFM-ADMIN-247
 */

/**
 * Role definitions for access control
 * These match the backend role values
 */
export const ROLES = {
  SUPER_ADMIN: 10,
  STAFF: 20,
};

/**
 * Check if user can view Payments report
 * @param {number} userRole - User's role from state.account.authUser.role
 * @returns {boolean} True if user has permission
 */
export const canViewPaymentsReport = (userRole) => {
  return userRole === ROLES.SUPER_ADMIN;
};

/**
 * Check if user can view Users report
 * @param {number} userRole - User's role from state.account.authUser.role
 * @returns {boolean} True if user has permission
 */
export const canViewUsersReport = (userRole) => {
  return userRole === ROLES.SUPER_ADMIN;
};

/**
 * Check if user can view Subscription Expiry report
 * @param {number} userRole - User's role from state.account.authUser.role
 * @returns {boolean} True if user has permission
 */
export const canViewSubscriptionReport = (userRole) => {
  // All authenticated users (both SUPER_ADMIN and STAFF) can view
  return true;
};

/**
 * Get default report tab based on user role
 * @param {number} userRole - User's role from state.account.authUser.role
 * @returns {string} Default tab key ("payments" | "subscription-expiry")
 */
export const getDefaultReportTab = (userRole) => {
  if (userRole === ROLES.SUPER_ADMIN) {
    return "payments";
  }
  // Default to subscription-expiry for STAFF and any other roles
  return "subscription-expiry";
};
